import * as React from 'react';
import { useAppSelector } from '../../@types/redux';
import { Typography, TextField } from '@mui/material';
import Screen from '../../components/Screen';
import IconButton from '@mui/material/IconButton';
import { sortBy } from 'lodash';
import { CustomChangeEvent, CustomMouseEvent } from '../../@types/helper';
import Paper from '@mui/material/Paper';
import ButtonBase from '@mui/material/ButtonBase';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const MasterDataManagement = () => {
    const [selectedLetter, setSelectedLetter] = React.useState<string | undefined>(undefined);
    const [searchFilter, setSearchFilter] = React.useState<string>('');

    const rights = useAppSelector(x => x.auth.session?.user?.rights);

    const masterDataScreens = useMemo(() => sortBy(rights?.filter(x => x.url?.startsWith('/masterData/') && !x.code.endsWith('_EDIT'))
        .map((x) => {
            return {
                label: x.name,
                url: x.url,
                disabled: !x.isActive,
            };
        }) ?? [], x => x.label), [rights]);

    const onLetterClick = (e : CustomMouseEvent) => {
        let letter = e.currentTarget.value;
        setSelectedLetter(prev => prev === letter ? undefined : letter);
    };

    const onSearchFilterChange = (e : CustomChangeEvent) => {
        setSearchFilter(e.currentTarget.value);
    };

    const filteredMasterDataScreens =  useMemo(() => {
        return masterDataScreens.filter((x) => {
            return x.label.toLowerCase().includes(searchFilter.toLowerCase())
                    && (selectedLetter === undefined || x.label.startsWith(selectedLetter));
        });
    }, [masterDataScreens, searchFilter, selectedLetter]);

    const activeAlphabet =  useMemo(() => {
        return alphabet.filter(letter => masterDataScreens.some(x => x.label.startsWith(letter)));
    }, [alphabet, masterDataScreens]);

    const activeAlphabetFiltered = useMemo(() => {
        return activeAlphabet.filter(letter => filteredMasterDataScreens.some(x => x.label.startsWith(letter)));
    }, [activeAlphabet, filteredMasterDataScreens]);

    return (
        <Screen isScrollable>
            <div className={'fdr jcc aic'}>
                {
                    alphabet.map((letter) => {
                        const disabled = !activeAlphabet.some(x => x === letter);

                        return (
                            <IconButton
                                key={`letter-${letter}`}
                                value={letter}
                                onClick={onLetterClick}
                                className={`w40 h40 ${selectedLetter === letter ? 'bcp cw' : ''}`}
                                disabled={disabled}>
                                <Typography>{letter}</Typography>
                            </IconButton>
                        );
                    })
                }
            </div>
            <div className={'fdr jcc aic'}>
                <TextField
                    label={'Search'}
                    name={'search'}
                    className={'w700'}
                    onChange={onSearchFilterChange}
                    value={searchFilter}
                />
            </div>
            <div className={'w700 fdc asc pb30'}>
                {
                    activeAlphabetFiltered.map((letter) => {
                        const screensForLetter = masterDataScreens.filter(x => x.label.startsWith(letter)
                                && x.label.toLowerCase().includes(searchFilter.toLowerCase()));

                        return (
                            <Paper key={`card-${letter}`} className={'jcfs aifs mt10 mb10 p20 pb10 pt10'}>
                                <div className={'fdc aifs'}>
                                    <Typography variant={'h5'}>{letter}</Typography>
                                    {
                                        screensForLetter.filter(x => x.label !== 'Management').map((screen) => {
                                            return (
                                                <Link key={`card-${letter}${screen.label}`} to={screen.url} style={{ textDecoration: 'unset', color: 'unset' }}>
                                                    <ButtonBase
                                                        disabled={screen.disabled}
                                                        value={screen.url}
                                                        className={'ml20 br5 p10 pt0 pb0'}>
                                                        <Typography
                                                            key={`nav-${screen.url}-${screen.label}`}
                                                            color={!screen.disabled ? 'textPrimary' : 'textSecondary'}
                                                            variant={'subtitle1'}>
                                                            {screen.label}
                                                        </Typography>
                                                    </ButtonBase>
                                                </Link>
                                            );
                                        })
                                    }
                                </div>
                            </Paper>
                        );
                    })
                }
            </div>
        </Screen>
    );
};

export default MasterDataManagement;
